import { NextSeo } from 'next-seo'

const Page = ({ name, path, children, ...rest }) => {
  const title = `Projectlink – ${name}`
  const url = `https://projectlink.app${path}`

  return (
    <>
      <NextSeo
        title={title}
        canonical={url}
        openGraph={{
          url,
          title,
        }}
        {...rest}
      />
      {children}
    </>
  )
}

export default Page